module.exports = __webpack_public_path__ + "img/photo-party-studio.7a25778d.jpg";